
export default function CircleShape({ baseX, baseY, radius, strokeWidth, opacity }) {
  return (
    <circle
        cx={baseX}
        cy={baseY}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        opacity={opacity / 100}
    />
  );
}


